require("dotenv").config();

export const authUrl2 = process.env.REACT_APP_API_DOMAIN;
const domain = process.env.REACT_APP_API_DOMAIN;

const api = "api/v1";

export const apiUrl = {
  coupons: {
    getCoupons: `${domain}/${api}/vendor/coupons?page=`,
    createCoupon: `${domain}/${api}/vendor/coupons`,
    updateCoupon: `${domain}/${api}/vendor/coupons/`,
  },
  orders: {
    getOrders: `${domain}/${api}/vendor/orders?page=`,
    getTabsCount: `${domain}/${api}/vendor/orders/tabs`,
    getOrderDetail: `${domain}/${api}/vendor/orders/`,
    updateOrderStatus: `${domain}/${api}/vendor/orders/`,
    generateOrderReceipt: `${domain}/${api}/vendor/orders/`,
    serchByCustomerId: `${domain}/${api}/vendor/orders/by_customer_id?customer_id=`,
    getPackingSlip: `${domain}/${api}/vendor/orders/`,
  },
  services: {
    getServices: `${domain}/${api}/vendor/services?page=`,
    getTabsCount: `${domain}/${api}/vendor/services/tabs`,
    getServiceDetail: `${domain}/${api}/vendor/services/`,
    createService: `${domain}/${api}/vendor/services`,
    updateService: `${domain}/${api}/vendor/services/`,
    deleteService: `${domain}/${api}/vendor/services/`,
    getRelatedServices: `${domain}/${api}/vendor/services/related_services`,
  },
  products: {
    getProducts: `${domain}/${api}/vendor/products?page=`,
    getTabsCount: `${domain}/${api}/vendor/products/tabs`,
    getProductDetail: `${domain}/${api}/vendor/products/`,
    createProduct: `${domain}/${api}/vendor/products`,
    updateProduct: `${domain}/${api}/vendor/products/`,
    deleteProduct: `${domain}/${api}/vendor/products/`,
    getRelatedProducts: `${domain}/${api}/vendor/products/related_products`,
    getRelatedTools: `${domain}/${api}/vendor/products/related_tools`,
  },
  export: {
    exportProducts: `${domain}/${api}/vendor/bulk_export`,
  },
  variants: {
    getVariants: `${domain}/${api}/vendor/products/`,
    createVariant: `${domain}/${api}/vendor/products/`,
    getVariantDetail: `${domain}/${api}/vendor/products/`,
    updateVariant: `${domain}/${api}/vendor/products/`,
    deleteVariant: `${domain}/${api}/vendor/products/`,
  },
  returns: {
    getReturns: `${domain}/${api}/vendor/refunds?page=`,
    getReturnDetail: `${domain}/${api}/vendor/refunds/`,
    updateReturnStatus: `${domain}/${api}/vendor/refunds/`,
  },
  shipmentRules: {
    getShipmentRules: `${domain}/${api}/vendor/shipment_rules`,
  },
  categories: {
    getCategories: `${domain}/${api}/vendor/categories`,
    getCategoriesForProductsServices: `${domain}/${api}/vendor/categories/for_product_service`,
  },
  profile: {
    getUsers: `${domain}/${api}/vendor/users?page=`,
  },
  brands: {
    getBrands: `${domain}/${api}/vendor/brands`,
    getBrandByCategory: `${domain}/${api}/vendor/brands/by_category?category_id=`,
  },
  vendorProfile: {
    getVendor: `${domain}/${api}/vendor/users/logged_in`,
    getVendorProfile: `${domain}/${api}/vendor/store`,
    changePassword: `${domain}/${api}/vendor/profile/change_password`,
  },
  createStore: {
    createVendor: `${domain}/auth`,
    createStore: `${domain}/${api}/vendor/store`,
    updateStore: `${domain}/${api}/vendor/store`,
    validateName: `${domain}/${api}/vendor/store/name_existence?store_name_en=`,
  },
  disputes: {
    getDisputes: `${domain}/${api}/common/disputes?role=vendor&page=`,
    getDisputeDetail: `${domain}/${api}/common/disputes/`,
    createReply: `${domain}/${api}/common/disputes/`,
    createDispute: `${domain}/${api}/common/disputes?role=vendor`,
  },
  reports: {
    getTotalSales: `${domain}/${api}/vendor/reports/total_sales?sale[start_date]=`,
    getOutofStockProducts: `${domain}/${api}/vendor/reports/out_of_stock_products`,
    getRecentOrders: `${domain}/${api}/vendor/reports/recent_orders?order[start_date]=`,
    getOrderTobeDelivered: `${domain}/${api}/vendor/reports/order_to_be_delivered?order[start_date]=`,
    getInventory: `${domain}/${api}/vendor/reports/inventory`,
    getTopProductsSold: `${domain}/${api}/vendor/reports/top_products_sold?product[limit]=`,
    getAverageOrderValue: `${domain}/${api}/vendor/reports/average_order_value?order[start_date]=`,
    getEarningAndCommissionPerOrder: `${domain}/${api}/vendor/reports/total_earning_invoice?earning[start_date]=`,
    getPlatformSettingID: `${domain}/${api}/vendor/platforms/platform_id`,
    getPlatformSetting: `${domain}/${api}/vendor/platforms`,
  },
  imports: {
    bulkImport: `${domain}/${api}/common/bulk_imports/import`,
  },
  emails: {
    sendEmail: `${domain}/${api}/vendor/emails/send_individual_email`,
  },
  dashboard: {
    getDashboardData: `${domain}/${api}/vendor/dashboard`,
  },
  banner: {
    updateBanner: `${domain}/${api}/vendor/banners/`,
    createBanner: `${domain}/${api}/vendor/banners`,
    getBanners: `${domain}/${api}/vendor/banners`,
    getBanner: `${domain}/${api}/vendor/banners`,
    deleteBanner: `${domain}/${api}/vendor/banners`,
    getBannerDetails: `${domain}/${api}/vendor/banners/`,
  },
  shop_banner: {
    updateBanner: `${domain}/${api}/vendor/shop_banners/`,
    createBanner: `${domain}/${api}/vendor/shop_banners`,
    getBanners: `${domain}/${api}/vendor/shop_banners`,
    getBanner: `${domain}/${api}/vendor/shop_banners`,
    deleteBanner: `${domain}/${api}/vendor/shop_banners`,
    getBannerDetails: `${domain}/${api}/vendor/shop_banners/`,
  },

  auth: {
    resetPass: `${domain}/auth/password`,
    validateToken: `${domain}/auth/validate_token`,
    signout: `${domain}/auth/sign_out`,
  },

  store: {
    getMenuItems: `${domain}/${api}/vendor/menu_items`,
    addMenuItem: `${domain}/${api}/vendor/menu_items`,
  },
  onboarding: {
    createStore: `${domain}/${api}/vendor/store/create_new_store`,
    updateBusinessDetails: `${domain}/${api}/vendor/store/update_store_business`,
    updateBankDetails: `${domain}/${api}/vendor/store/update_bank_details`,
    updateTermsConditions: `${domain}/${api}/vendor/store/update_terms_conditions`,
  },
};
